import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';

function StatisticsComp({ numberOfdays, countWeekOf, userId }) {

    const Today_HRS = useSelector((state) => state?.attendenace?.Today_HRS);
    var clearMinutes = Today_HRS ? Today_HRS % 60 : '';
    var Today_Total_MINUTS = parseInt(clearMinutes) < 10 ? '0' + clearMinutes : clearMinutes;
    var Today_Total_HRS = parseInt(Today_HRS / 60) < 10 ? '0' + parseInt(Today_HRS / 60) : parseInt(Today_HRS / 60);

    const week_total_HRS = useSelector((state) => state?.attendenace?.week_att_time);

    const month_total_HRS = useSelector((state) => state?.attendenace?.month_att_time);
    // console.log('month_total_HRS=>', month_total_HRS)
    return (
        <div className="dash_white_box2 mb20 mh314">
            <div className="dash_white_box_ttl">Statistics</div>
            <div className="pun_cont_wrp">
                <div className="punch_wrp mb15">
                    <div className="progress_ttl">
                        Today
                        <div className="progress_text">
                            {Today_Total_HRS ? Today_Total_HRS : '00'}:{Today_Total_MINUTS ? Today_Total_MINUTS : ''}/7 <span className="pro_hrs">hrs</span>
                        </div>
                    </div>
                    <div className="progress_bar">
                        <div className="pro_b progress-cgreen"
                            style={{ width: `${(((parseFloat(Today_Total_HRS * 60) + parseFloat(Today_Total_MINUTS)) * 1.7) / 9) + "%"}` }}
                        ></div>
                    </div>
                </div>
                <div className="punch_wrp">
                    <div className="progress_ttl">
                        This Week

                        <div className="progress_text">
                            {(Math.floor(week_total_HRS / 60) == 0 ? '00' : Math.floor(week_total_HRS / 60))}
                            :{week_total_HRS % 60}/35 <span className="pro_hrs">hrs</span>
                            -{week_total_HRS}
                        </div>
                    </div>
                    <div className="progress_bar">
                        <div className="pro_b progress-red"
                            style={{ width: `${((week_total_HRS * 1.7) / 35) + "%"}` }}
                        ></div>
                    </div>
                </div>


                <div className="punch_wrp">
                    <div className="progress_ttl">
                        This Month 
                        <div className="progress_text">
                            {(Math.floor(month_total_HRS / 60) == 0 ? '00' : Math.floor(month_total_HRS / 60))}
                            :{month_total_HRS % 60}
                            /{numberOfdays ? (numberOfdays - countWeekOf) * 7 : ''} <span className="pro_hrs">hrs</span>
                        </div>
                    </div>
                    <div className="progress_bar">
                        <div className="pro_b progress-orange"
                        // style={{ width: `${((month_total_HRS * 1.7) / 198) + "%"}` }}
                        ></div>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default StatisticsComp
